import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const ProctorGroupList = observer(class ProctorGroupList extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.expandGroup = this.expandGroup.bind(this);
  }

  componentWillMount() {
    this.state = {
      expanded: []
    }
  }

  expandGroup(i) {
    const expanded = [...this.state.expanded];
    const thisIndex = this.state.expanded.indexOf(i);

    if(thisIndex === -1) {
      expanded.push(i);
    } else {
      expanded.splice(thisIndex, 1);
    }

    this.setState({
      expanded
    });
  }

  render() {
    const { proctorGroups, translation } = this.props;

    return (
      <div>
        {proctorGroups && proctorGroups.map(
          (proctorGroup, i) => {
            return (
              <section
                className={`block block--sm ${this.props.noExpand ? 'block--scale' : ''}`}
                key={proctorGroup.sid}
              >
                {!this.props.noExpand &&
                  <h5
                    className="block__title block__title--sm"
                    onClick={() => this.expandGroup(i)}
                  >
                    {proctorGroup.title}

                    <button
                      className="btn--link"
                      onClick={() => this.expandGroup(i)}
                    >
                      {this.state.expanded.indexOf(i) === -1 &&
                        <icons.iconChevronDown />
                      }

                      {this.state.expanded.indexOf(i) > -1 &&
                        <icons.iconChevronUp />
                      }

                      <span className="meta">Expand</span>
                    </button>
                  </h5>
                }

                {this.props.noExpand &&
                  <h5
                    className="block__title block__title--sm"
                  >
                    {proctorGroup.title}
                  </h5>
                }

                {
                  (this.state.expanded.indexOf(i) > -1 || this.props.noExpand) &&
                  proctorGroup.proctorLocationSids &&
                  proctorGroup.proctorLocationSids.length > 0 &&

                  <p>
                    {proctorGroup.proctorLocationSids.length}&nbsp;

                    {proctorGroup.proctorLocationSids.length === 1 &&
                      translation.location
                    }

                    {proctorGroup.proctorLocationSids.length !== 1 &&
                      translation.locations
                    }
                  </p>
                }

                {
                  (this.state.expanded.indexOf(i) > -1 || this.props.noExpand) &&
                  proctorGroup.proctorTypes &&
                  proctorGroup.proctorTypes.length > 0 &&
                  <span className="title">{translation.types}</span>
                }

                {(this.state.expanded.indexOf(i) > -1 || this.props.noExpand) &&
                  <ul>
                    {proctorGroup.proctorTypes.map(
                      (proctorType, j) => {
                        return (
                          <li
                            className="truncate"
                            key={j}
                            title={proctorType}
                          >
                            {proctorType}
                          </li>
                        )
                      }
                    )}
                  </ul>
                }
              </section>
            )}
          )
        }
      </div>
    )
  }
})

export default translate('ProctorGroupList')(ProctorGroupList);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ProctorGroupList.js